import customerService from '../service/customer'
const state = {
    customers: [],
    loading: false
}

const actions = {
    updateCustomer({ commit }, form) {
        return customerService.updateCustomer(form).then(() => {
            commit('updateCustomer', form);
        })
    },
    createCustomer({ commit }, customer) {
        return customerService.createCustomer(customer).then(data => {
            customer._id = data.customer._id;
            commit('addCustomer', customer);
            return data;
        })
    },
    getCustomers({ commit }) {
        commit('setLoading', true)
        return customerService.getCustomers().then(customers => {
            commit('setCustomers', customers);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    updateCustomer(state,form) {
        let index = state.customers.findIndex(x=>x._id == form.id)
        if(index != -1){
            state.customers[index].name = form.name
            state.customers[index].address = form.address
            state.customers[index].email= form.email
            state.customers[index].mobileUserLimit = form.mobileUserLimit
            state.customers[index].phone = form.phone
            state.customers[index].logo = form.logo
        }
    },
    addCustomer(state, customer) {
        state.customers.push(customer)
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setCustomers(state, customers) {
        state.customers = customers
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



